import {
  Control,
  Controller,
  FieldError,
  FieldValues,
  Path,
} from 'react-hook-form';
import { FormHelperText, TextField } from '@mui/material';
import { useRef } from 'react';

interface InputFileUploadProps<K extends FieldValues> {
  name: Path<K>;
  control: Control<K>;
  error?: FieldError;
  label?: string;
  accept?: string;
  disabled?: boolean;
  readonly?: boolean;
  fileKey?: any;
  onFileChange?: (file: File | null) => void;
}

export default function InputFileUpload<K extends FieldValues>({
  name,
  control,
  error,
  label,
  accept = '.txt',
  disabled = false,
  readonly = false,
  fileKey = null,
  onFileChange,
}: InputFileUploadProps<K>) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <TextField
            label={label}
            value={field.value?.name || ''}
            fullWidth
            autoComplete="off"
            margin="dense"
            variant="standard"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <button
                  type="button"
                  disabled={disabled || readonly}
                  style={{
                    border: 'none',
                    background: 'transparent',
                    color: '#1976d2',
                    cursor: 'pointer',
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  Subir
                </button>
              ),
            }}
            error={!!error}
            sx={{ minWidth: 200 }} // puedes ajustar este valor si necesitas más anchura
          />
          {error && (
            <FormHelperText error>
              {error.message}
            </FormHelperText>
          )}
          <input
            type="file"
            accept={accept}
            hidden
            ref={fileInputRef}
            disabled={disabled || readonly}
            key={fileKey}
            onChange={(e) => {
              console.log("SE CAMBIA ARCHIVO")
              field.onChange(null);
              onFileChange?.(null);
              const file = e.target.files?.[0] || null;
              field.onChange(file);
              onFileChange?.(file);
            }}
          />
        </>
      )}
    />
  );
}
